import { type INode } from '@/lib/ris-types'
import { type FunctionComponent } from 'react'
import Inline from '../Inline/Inline'
import * as styles from './Table.css'

const Table: FunctionComponent<INode> = function Table (props) {
  return (
    <div className={styles.root}>
      <table
        // @ts-expect-error Hack to be able to use a string as style attribute. See https://stackoverflow.com/a/67375810/8464260
        STYLE={props.style ?? ''}
        cellSpacing={0}
        className={styles.table}
      >
        <tbody>
          {props.children?.map((row: INode, rowIndex) => {
            if (row.type === 'tr') {
              return (
                <tr
                  // @ts-expect-error Hack to be able to use a string as style attribute. See https://stackoverflow.com/a/67375810/8464260
                  STYLE={row.style ?? ''}
                  key={rowIndex}
                >
                  {row.children?.map((column: INode, columnIndex) => {
                    if (column.type === 'th') {
                      return (
                        <th key={columnIndex}>
                          <Inline
                            {...column}
                          />
                        </th>
                      )
                    } else if (column.type === 'td') {
                      return (
                        <td
                          // @ts-expect-error Hack to be able to use a string as style attribute. See https://stackoverflow.com/a/67375810/8464260
                          STYLE={column.style ?? ''}
                          key={columnIndex}
                          colSpan={column.colspan}
                          rowSpan={column.rowspan}
                        >
                          <Inline
                            {...column}
                          />
                        </td>
                      )
                    }

                    return null
                  })}
                </tr>
              )
            } else {
              return null
            }
          })}
        </tbody>
      </table>
    </div>
  )
}

export default Table
